
import { Constantes } from "@/Util/Constantes";
import { Utilidades } from "@/Util/Utilidades";
import { Postit } from "@/model/Postit";
import { PostitService } from "@/services/PostitService";
import Vue from "vue";

export default Vue.extend({
  name: "Postit",
  props: {
    postit: Object as () => Postit,
    ejemplo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getTextClass(): string {
      return `${this.postit.css_texto}--text ${this.postit.css_fondo} py-1`;
    },
    getTitleClass(): string {
      return `${this.postit.css_texto_titulo}--text ${this.postit.css_fondo_titulo} py-1`;
    },
    getStyle(): string {
      return `position: absolute; z-index: 1002; top: ${this.postit.top}px; left: ${this.postit.left}px; width: ${this.postit.ancho}px !important; height ${this.postit.alto}px !important`;
    },
  },
  data() {
    return {
      loading: false as boolean,
      mostrar: true as boolean
    };
  },
  methods: {
    async leido() {
      if (this.ejemplo) {
        this.$emit("cerrar");
        return;
      }

      this.loading = true;

      await PostitService.postitLeido(this.postit.id_postit)
        .then((x) => {
          this.mostrar = false;
          Utilidades.Message({ message: Constantes.DATOS_GRABADOS });
        })
        .catch(() => {
          Utilidades.Message({
            message: Constantes.ERROR_GRABAR_DATOS,
            error: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
